import { ExternalDocumentationObjectSchema as OriginalExternalDocumentationObjectSchema } from '../processed/external-documentation-object'

/**
 * External Documentation Object
 *
 * Allows referencing an external resource for extended documentation.
 *
 * @see https://github.com/OAI/OpenAPI-Specification/blob/main/versions/3.1.1.md#external-documentation-object
 */
export const ExternalDocumentationObjectSchema = OriginalExternalDocumentationObjectSchema
